// import previewUrl from "../../images/preview_test.jpg";
const previewDefault = {
  // url: previewUrl,
  url: null,
  width: null,
  height: null
};
const preview = (state = previewDefault, action) => {
  switch (action.type) {
    case "START_GENERATING_MOSAIC":
      return previewDefault;
    case "FINISH_GENERATING_MOSAIC":
      return {
        url: action.url,
        width: action.width,
        height: action.height
      };
    default:
      return state;
  }
};
export default preview;



// WEBPACK FOOTER //
// ./src/reducers/mosaic/preview.js